import React from "react";

interface NoDataProps {
  message?: string;
}

const NoData: React.FC<NoDataProps> = ({ message = "No Data" }) => {
  return (
    <div className="text-gray-500 text-center py-4">
      <p>{message}</p>
    </div>
  );
};

export default NoData;
